export enum FleetCreationSource {
    AdminPortal = 'ADMIN_PORTAL',
    DriverApp = 'DRIVER_APP',
}